/*global mod*/

(function($, mod) {

	var urls = {
		load: "~/f2/apps/json",
		async: "~/f2/async/"
	};

	var helpers = {

		// Put app html onto the page
		loadWidgets: function(widgets, container, inputs) {
			for (var i = 0, len = widgets.length; i < len; i++) {
				var widget = widgets[i];
				var status = widget.status;
				var html = widget.html;

				if (status === "SUCCESS") {
					var $newWidget = $(html);
					var widgetId = $newWidget.attr("id");

					if (container) {
						$newWidget.appendTo(container);
					}
					else {
						var $existing = $(document.getElementById(widgetId));

						if ($existing.length) {
							// Remove existing class instances
							var widgetClass = $existing.data("widget");

							if (widgetClass) {
								widgetClass.dispose();
							}

							$existing.replaceWith($newWidget);
						}
					}
				}
				else {
					var tryId = inputs && inputs.length >= i && inputs[i].appId;
					console.error("widget '" + (tryId || "unknown") + "' failed to load (" + status + ")");
				}
			}
		},

		// Execute javascript inlines
		loadInlineScripts: function(inlines) {
			for (var i = 0, len = inlines.length; i < len; i++) {
				try {
					eval(inlines[i]);
				}
				catch (e) {
					mod.warn("mod.modules.widgetapi - inlines" + e);
				}
			}
		}

	};

	mod.modules.widgetapi = {

		_loadDefaults: {
			widgets: [],
			disableInlines: false,
			container: null,
			success: function() { },
			error: function() { },
			complete: function() { }
		},

		// Call the server with params to load widgets
		load: function(params) {
			// Sometimes we'll just get an array of widgets to load
			// When this occurs, we'll just throw them into a new object
			if (params instanceof Array) {
				params = {
					widgets: params
				};
			}

			// Tack on the defaults
			params = $.extend({}, mod.modules.widgetapi._loadDefaults, params);

			// Only load apps that passed an appId
			for (var i = 0; i < params.widgets.length; i++) {
				if (!params.widgets[i].appId) {
					params.widgets.splice(i, 1);
					i -= 1;
				}
			}

			// Make sure the widgets are in array format (for F2)
			if (params.widgets instanceof Array === false) {
				params.widgets = [params.widgets];
			}

			return $.ajax({
				url: urls.load.resolveUrl(),
				cache: false,
				data: {
					params: JSON.stringify(params.widgets)
				},
				success: function(response) {
					helpers.loadWidgets(response.apps, params.container, params.widgets);

					if (!params.disableInlines) {
						helpers.loadInlineScripts(response.inlineScripts);
					}

					params.success(
						response,
						// Pass back a method that will execute the inlines when called
						function() { helpers.loadInlineScripts(response.inlineScripts); }
					);
				},
				error: function() {
					params.error(this);
				},
				complete: params.complete
			});
		},

		_asyncDefaults: {
			inputs: {},
			success: function() { },
			error: function() { },
			complete: function() { },
			beforeSend: function() { }
		},

		// Asynchronosly call an apps "RenderAsync" method
		async: function(params) {
			if (params.inputs instanceof Array === false) {
				params.inputs = [params.inputs];
			}

			return $.ajax({
				url: urls.async.resolveUrl(),
				cache: false,
				data: {
					params: JSON.stringify(params.inputs)
				},
				beforeSend: params.beforeSend,
				success: function(response) {
					if (response.status == "SUCCESS") {
						params.success(response);
					}
					else {
						params.error(this);
					}
				},
				error: function() {
					params.error(this);
				},
				complete: params.complete
			});
		}

	};

	// ------------------------------------------------------------------------
	// Base Module additions
	// ------------------------------------------------------------------------

	// Allow the module to reload itself with new data
	mod.modules.base.prototype.reload = function(data, recursive) {
		data = data || {};

		this.showLoading();

		var deepCopy = (recursive === undefined ? true : recursive);
		data = $.extend(deepCopy, {}, this.getContext(), data);

		// Load the module from WidgetApi
		mod.modules.widgetapi.load({
			widgets: {
				appId: this.el.attr("data-widgetid"),
				context: data
			}
		});
	};

	// Add the widget to the reload queue
	mod.modules.base.prototype.reloadQueue = function(data) {
		this.showLoading();

		data = $.extend(true, {}, this.getContext(), data || {});

		// Queue the module for reload
		mod.observer.queue("reload", {
			appId: this.el.attr("data-widgetid"),
			context: data
		});
	};

	mod.modules.base.prototype.reloadDequeue = function() {
		mod.observer.dequeue("reload", mod.modules.widgetapi.load);
	};

	mod.modules.base.prototype.ajax = function(inputs, callback, supressLoading) {
		var self = this;

		var widgetId = this.el.attr("data-widgetid");
		var context = $.extend({}, this.getContext(), inputs);
		var params = [{ appId: widgetId, context: context }];

		return mod.modules.widgetapi.async({
			inputs: params,
			context: this,
			beforeSend: function() {
				if (!supressLoading) {
					self.showLoading();
				}
			},
			success: function(response) {
				self.el.removeClass("module-hasError");

				if (callback) {
					callback(response);
				}
			},
			error: function(xhr) {
				self.el.addClass("module-hasError");

				if (self.ajax_error) {
					self.ajax_error(xhr);
				}
			},
			complete: function() {
				self.hideLoading();
			}
		});
	};

}(jQuery, window.mod));